import EvacuationsPage from './components/EvacuationsPage';

const routes = [
  {
    path: '/evacuations',
    name: 'menu.evacuations',
    icon: 'exclamation-diamond',
    // customIcon: true,
    loginRequired: true,
    component: EvacuationsPage,
    weight: 2,
    permission: [],
    children: [],
  },
];

export default routes;
